import React from 'react';

function isModifiedEvent(event: React.MouseEvent<HTMLAnchorElement>) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const ActionLink = (
  props:
    | React.DetailedHTMLProps<
        React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLAnchorElement
      > & {
        onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
        disabled?: boolean;
      },
) => {
  const { onClick, target, disabled, href } = props;

  const rest = {
    ...props,
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (disabled) {
        return;
      }
      try {
        if (onClick) onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (
        !event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore everything but left clicks
        (!target || target === '_self') && // let browser handle "target=_blank" etc.
        !isModifiedEvent(event) && // ignore clicks with modifier keys
        !href // if href passed, treat like regular link
      ) {
        event.preventDefault();
      }
    },
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <a {...rest}>{props.children}</a>;
};

export default ActionLink;
